import yup from 'utils/yup';

export const initialBreakModalFormValue = {
  break_duration: 0,
  setBreakTime: [],
  start: undefined as undefined | Date,
  end: undefined as undefined | Date,
};

export const breakFormValidationSchema = yup.object().shape({
  break_duration: yup.number().required(),
  end: yup.date().when('setBreakTime', {
    is: (setBreakTime: any) => setBreakTime.includes('yes'),
    then: yup
      .date()
      .required()
      .test('end-after-start', { msg: 'End time must be after start time' }, function (value) {
        const { start } = this.parent;
        return !start || !value || value >= start;
      }),
  }),
  start: yup.date().when('setBreakTime', {
    is: (setBreakTime: any) => setBreakTime.includes('yes'),
    then: yup
      .date()
      .required()
      .test('start-before-end', { msg: 'Start time must be before end time' }, function (value) {
        const { end } = this.parent;
        return !end || !value || value <= end;
      }),
  }),
});
